import Swiper from 'swiper/dist/js/swiper.js';
//import SVGMarker from '@defvayne23/svg-marker/SVGMarker.js'; // eslint-disable-line

export class variationPrice {
  constructor() {
    jQuery('.single_variation').bind("DOMSubtreeModified", () => { this.maj(); });
  }
  maj() {
    let attr = jQuery('.variation-control option:selected').text()
    let price = jQuery('.pomelo-variation-price').text();
    let is_in_stock = jQuery('#is_in_stock_'+jQuery('.variation-control option:selected').val()).val();
    if(price !== '' && attr !== '') {
      price = this.traitementPrix(price);
      jQuery('.product-price .price').text(price);
      attr = this.traitementAttr(attr);
      jQuery('.product-price .attr').text(attr);
    }
    if(is_in_stock != "1") {
      jQuery('.backorder_notification').css('display', 'block');
    }
  }
  traitementPrix(price) {
    return parseFloat(price.trim().replace(',', '.'));
  }
  traitementAttr(attr) {
    return attr.trim();
  }
}
export class instagramFeed {
  constructor(token, user_id, num_photos, selector) {
    this.ajax(selector, token, user_id, num_photos);
  }
  ajax(selector, token, user_id, num_photos) {
    var _this = this;
    var returnText = '';
    jQuery.ajax({
      url: `https://api.instagram.com/v1/users/${user_id}/media/recent`,
      type: 'GET',
      dataType: 'jsonp',
      crossDomain: true,
      data: {
        access_token: token,
        count: num_photos,
      },
      success(reponse) {
        returnText += '<div class="swiper-container instagram-slider"><div class="swiper-wrapper">';
        for (let x in reponse.data) {
          returnText += `<div class="swiper-slide"><a href="${reponse.data[x].link}" target="_blank"><span class="imgInsta" style="background: url(${reponse.data[x].images.low_resolution.url}) no-repeat; background-size: cover; background-position: center center"></span></a></div>`;
        }
        returnText += '</div></div>';
        _this.show(selector, token, user_id, num_photos, returnText);

      },
      error() {
        returnText = false;
      },
    });
  }
  initSlider() {
    new Swiper('.instagram-slider', {
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      loop: true,
      height: 200,
      spaceBetween: 0,
      slidesPerView: 'auto',
      on: {
        resize: function () {
          this.update();
        },
      },
    });
  }
  show(selector, token, user_id, num_photos, feed) {
    jQuery(selector).append(feed);
    this.initSlider();
  }
}
export class ResponsiveBackgroundImage {
  constructor(element) {
      this.element = element;
      this.img = element.querySelector('img');
      this.src = '';

      if(this.img != null) {
        this.img.addEventListener('load', () => {
          this.update();
        });

        if (this.img.complete) {
            this.update();
        }
      }
  }

  update() {
      let src = typeof this.img.currentSrc !== 'undefined' ? this.img.currentSrc : this.img.src;
      if (this.src !== src) {
          this.src = src;
          this.element.style.backgroundImage = 'url("' + this.src + '")';

      }
  }
}

export default {
  init() {
    if(jQuery('.search-item .main_img').length == 1) {
      jQuery('.search-item .main_img, .search-item .btnclose').click(function(){
        jQuery(this).parents('.search-item').toggleClass('active');
      });
    }
    /* Slider */
    var mainSlider = new Swiper('.main-slider', {
      autoplay: {
        delay: 15000,
        disableOnInteraction: false,
      },
      speed: 600,
      effect: 'fade',
      centeredSlides: true,
      loop: true,
      slidesPerView: 1,
      preloadImages: true,
      updateOnImagesReady: true,
      setWrapperSize: true,
      spaceBetween: 50,
      on: {
        resize: function () {
          this.update();
        },
      },
    });
    jQuery(window).on('orientationchange', function() {
      setTimeout(function() {
        if(jQuery(".mainSlider").length > 0) {
          mainSlider.update();
        }
      }, 500);
    });
    var sideSlider = new Swiper('.side-slider', {
      autoplay: {
        delay: 15000,
        disableOnInteraction: false,
      },
      speed: 600,
      centeredSlides: true,
      parallax: true,
      slidesPerView: 1,
      preloadImages: true,
      updateOnImagesReady: true,
      loop: true,
      navigation: {
        nextEl: '.side-next',
      },
      setWrapperSize: true,
      spaceBetween: 50,
      on: {
        resize: function () {
          this.update();
        },
      },
    });
    jQuery(window).on('orientationchange', function() {
      setTimeout(function() {
        if(jQuery(".side-slider").length > 0) {
          sideSlider.update();
        }
      }, 500);
    });
    new instagramFeed('1125371289.aa03c7f.5eaba379737b4854b2e0e12f31c392c3', '1125371289', 25, '#instagram');

    let elements = document.querySelectorAll('[data-responsive-background-image]');
    for (let i=0; i<elements.length; i++) {
      new ResponsiveBackgroundImage(elements[i]);
    }
    /* MAIN MENU */
    if(jQuery('.homepage-slider').length == 0) {
      jQuery('.nav-primary .nav > li.menu-item').on("mouseenter", function() {
        jQuery('header.banner').addClass('expand-banner');
      }).on("mouseleave", function() {
        jQuery('header.banner').removeClass('expand-banner');
      });
    }
    jQuery('.menu-mobile li.menu-item-has-children > a').on("mouseenter click", function(e) {
      e.preventDefault();
      var subMenu = $(this).find('~ ul.sub-menu');
      if(jQuery(subMenu).is(':visible')) {
        jQuery('.menu-mobile li.menu-item-has-children .sub-menu').css('display','none');
        jQuery(subMenu).css('display','none');
      } else {
        jQuery('.menu-mobile li.menu-item-has-children .sub-menu').css('display','none');
        jQuery(subMenu).css('display','block');
      }
      jQuery('header.banner').addClass('expand-banner');
    });
    /* CART POPOVER */
    jQuery('#cart-contents-popover, #cart-contents-popover-mob').on('click', function(e) {
      e.preventDefault();
      jQuery('#content-cart-mini').addClass('active').removeClass('hide');
    });
    jQuery('#content-cart-mini').find('.close').bind('click', function(e) {
        e.preventDefault();
        jQuery('#content-cart-mini').removeClass('active hide');
    });
    /* NAV LANG */
    jQuery('.nav-top-left').on('onmouseover', function() {
      let $thisNav = $(this);
      $thisNav.addClass('show');
      $thisNav.find('.dropdown').addClass('show');
    }).on('onmouseout', function() {
      let $thisNav = $(this);
      $thisNav.removeClass('show');
      $thisNav.find('.dropdown').removeClass('show');
    });
    /* ANCHOR LINK */
    jQuery(document).on('click', 'a[href^="#"]:not([data-toggle="modal"]):not([data-anchor="false"]):not([data-load="all"])', function (event) {
      event.preventDefault();
      var thisLink = jQuery.attr(this, 'href');
      if(jQuery(thisLink).length > 0) {
        jQuery('html, body').animate({
          scrollTop: jQuery(thisLink).offset().top,
        }, 500);
      }
    });
    /* SOCIAL NETWORK */
    jQuery('a[data-social-share="true"]').on('click', function(e) {
      e.preventDefault();
      let $thisSocial = jQuery(this),
          socialMedia = $thisSocial.data('social-media'),
          socialUrl = escape($thisSocial.attr('href')),
          socialText = $thisSocial.data('social-text'),
          socialImage = $thisSocial.data('social-image'),
          url;

      switch (socialMedia) {
        case "facebook":
            url = "https://www.facebook.com/sharer/sharer.php?u=" + socialUrl;
            break;
        case "twitter":
            url = "https://twitter.com/intent/tweet?text=" + socialText + "&url=" + socialUrl;
            break;
        case "pinterest":
            url = "https://pinterest.com/pin/create/button/?url=" + socialUrl + "&media=" + socialImage + "&description=" + socialText;
            break;
        case "googleplus":
            url = "https://plus.google.com/share?url=" + socialUrl + "&hl=fr-FR";
            break;
    }
    return window.open(url, 'popUpWindow', 'height=500,width=600,left=250,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no,status=yes')
    });
  },
  finalize() {
    new variationPrice;

    function magicHiddenCart() {
      let cartMiniHeight = jQuery('#content-cart-mini').height();
      if(jQuery(window).scrollTop() > (cartMiniHeight/1.25)) {
        jQuery('#content-cart-mini').removeClass('active hide');
      }
    }
    jQuery(window).on("scroll", magicHiddenCart);

    jQuery('body').on('adding_to_cart wc_cart_button_updated', function(e, el) {
      jQuery(window).off("scroll", magicHiddenCart);
      var $thisbutton = el;
      let textAddedButton = $thisbutton.data('added-text');
      let textDefaultButton = $thisbutton.data('default-text');
      if ( $thisbutton.is('.loading') ) {
        $thisbutton.addClass('disabled');
        $thisbutton.html($thisbutton.data('loading-text'));
      }
      if ( $thisbutton.is('.added') ) {
        $thisbutton.html(textAddedButton);
        setTimeout(function () {
          $thisbutton.html(textDefaultButton);
          $thisbutton.removeClass('disabled');
        }, 5000);
      }
    });

    jQuery('body').on('wc_fragments_loaded', function() {
      jQuery('#content-cart-mini').addClass('active').removeClass('hide');
      jQuery('html, body').animate({
        scrollTop: jQuery('#content-cart-mini').offset().top,
      }, 300);
      let $totalCartItem = jQuery('.cart-mini-total-item').text();
      if($totalCartItem != '') { jQuery('.cart-count-total').text($totalCartItem); }
      setTimeout(function () {
        jQuery(window).on("scroll", magicHiddenCart);
      }, 1000);
    });

    jQuery(document).ready(() => {
      // Mise en forme des select
      const customSelects = document.querySelectorAll(".oceopin-dropdown__select");
      for(let i=0; i<customSelects.length; i++){
          if (customSelects[i].hasAttribute("disabled")){
              customSelects[i].parentNode.className += " oceopin-dropdown--disabled";
          }
      }

      jQuery('#nav-icon').click(function(){
        if(jQuery('body').hasClass('menu-mobile-open')) {
          jQuery('body').removeClass('menu-mobile-open');
          /*setTimeout(function() {
            jQuery('body').removeClass('menu-mobile-open-preprocess');
            setTimeout(function() {
              jQuery('body').removeClass('menu-mobile-open-process');
            }, 300);
          }, 500);*/
        } else {
          jQuery('html, body').animate({ scrollTop: 0 }, 500);
          /*jQuery('body').addClass('menu-mobile-open-preprocess');
          setTimeout(function() {
            jQuery('body').addClass('menu-mobile-open-process');
            setTimeout(function() {*/
              jQuery('body').addClass('menu-mobile-open');
            /*}, 150);
          }, 150);*/
        }
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js